import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=4343ec66&scoped=true&"
import script from "./sobre.vue?vue&type=script&lang=js&"
export * from "./sobre.vue?vue&type=script&lang=js&"
import style0 from "./sobre.vue?vue&type=style&index=0&id=4343ec66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343ec66",
  null
  
)

export default component.exports